import { useMemo } from "react";
import Hero from "@/pages/home/components/Hero";
import StatsBand from "@/pages/home/components/StatsBand";
import FeaturedClues from "@/pages/home/components/FeaturedClues";
import ProcessSteps from "@/pages/home/components/ProcessSteps";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import PlatformPrinciples from "@/pages/home/components/PlatformPrinciples";
import FaqPreview from "@/pages/home/components/FaqPreview";
import CtaBanner from "@/pages/home/components/CtaBanner";
import { useSeo } from "@/hooks/useSeo";
import { site } from "@/mocks/site";

function Home() {
  const jsonLd = useMemo(
    () => [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: site.name,
        alternateName: "匿名爆料与线索汇聚中心",
        url: "https://gregbennettguitars.com.cn/",
        description: site.description,
        inLanguage: "zh-CN",
        potentialAction: {
          "@type": "SearchAction",
          target: "https://gregbennettguitars.com.cn/clues?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: site.name,
        url: "https://gregbennettguitars.com.cn/",
        email: site.email,
        description: site.tagline,
      },
    ],
    []
  );

  useSeo({
    title: "爆料平台 - 匿名爆料入口与内部消息投稿处 | 线索汇聚中心",
    description:
      "爆料平台是匿名爆料入口与内部消息投稿处，也是线索汇聚中心。可直接提交聊天截图、文件或身边线索；平台对内部消息、公众事件和维权内容进行归档归类，后续核实与更新在对应入口同步。",
    keywords: "爆料平台,匿名爆料,内部消息,线索提交,身边事,维权线索",
    path: "/",
    jsonLd,
  });

  return (
    <>
      <Hero />
      <StatsBand />
      <FeaturedClues />
      <ProcessSteps />
      <CategoryGrid />
      <PlatformPrinciples />
      <FaqPreview />
      <CtaBanner />
    </>
  );
}

export default Home;